//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SUCCESS_CODE } from "@/service/httpCode";
import { getThemeByType } from "@/js/utils";

export default {
    data() {
        return {
            isLoading: false,
            isCopyBtnShow: true,
            show: false,
            amount: "",
            themeType: "",
            qaList: [
                {
                    q: "Q：一定要使用本人银行卡转账吗？",
                    a: "A: 是的。他人银行卡转账无法帮您还款噢，资金将退回原账号。",
                },
                {
                    q: "Q: 还款金额超过银行卡转账限额怎么办？",
                    a: "A: 您可使用多张本人银行卡转账，当日转账累计达应还金额即可。建议添加转账备注姓名手机号，更快完成还款。",
                },
                {
                    q: "Q: 不小心转账多了怎么办？",
                    a: "A: 我们将按您点击还款登记时的页面展示金额进行还款，多余金额将在3个工作日内退还原银行账户。",
                },
                {
                    q: "Q: 转账后扣了钱，但没有收到还款成功通知怎么办？",
                    a: "A: 请确认转账金额达应还金额，并在本页面点击了还款登记。大约需要2个工作日内帮您确认还款。",
                },
            ],
            corporateAccount: {
                bankAccountName: "",
                bankAccount: "",
                bankName: "",
            },
            showRepayPlan: false,
            repayPlanList: [],
        };
    },
    computed: {
        accountInfo() {
            return [
                {
                    title: "收款方户名",
                    linkText: "复制户名",
                    value: this.corporateAccount.bankAccountName,
                },
                {
                    title: "收款方账号",
                    linkText: "复制账号",
                    value: this.corporateAccount.bankAccount,
                },
                {
                    title: "省份/开户行",
                    linkText: "复制开户行",
                    value: this.corporateAccount.bankName,
                },
            ];
        },
    },
    methods: {
        remark() {
            this.showTheLoading(async () => {
                const { orderNo } = this.$store;
                const { result } = await this.$http.combineRepay(orderNo);
                if (result === SUCCESS_CODE) {
                    this.show = true;
                }
            });
        },
        showToast(text) {
            this.$vux.toast.text(text, "middle");
        },
        onCopy() {
            this.showToast("复制成功");
        },
        onError(e, value) {
            if (this.isApp) {
                // 理财app新版本
                PPDWebUI.FinancialService.copy(
                    {
                        copyContext: value,
                    },
                    () => {
                        this.showToast("复制成功");
                    },
                    () => {
                        this.showToast(
                            "您的手机浏览器暂不支持复制功能，请手动复制！"
                        );
                    }
                );
            } else {
                this.showToast("您的手机浏览器暂不支持复制功能，请手动复制！");
            }
        },
    },
    async created() {
        this.isLoading = true;
        this.$vux.loading.show();
        const { orderNo } = this.$store;
        // this.isKoo = bizCode === "105";
        const { data, result } = await this.$http.combineLoad(orderNo);
        if (result === SUCCESS_CODE) {
            const { amount, combineList, offBankVo, themeType, sourceTitle } =
                data;
            this.amount = amount;
            this.repayPlanList = combineList;
            this.themeType = getThemeByType(themeType || "0");
            this.corporateAccount = Object.assign(
                {},
                this.corporateAccount,
                offBankVo
            );
            this.$bus.$emit("update-title", {
                hasHeader: sourceTitle,
            });
        }
        this.$vux.loading.hide();
        this.isLoading = false;
    },
};
